import "../../css/blocks/legal-boxes.css";

// Wait for the window to fully load before initializing
window.addEventListener("load", () => {
  const legalBoxesBlocks = document.querySelectorAll(".legal-boxes");

  if (legalBoxesBlocks.length) {
    // Initialize block-specific functionality here
  }
});
